import { theme } from "../styles/theme";

export const ClusterLayer = (skin) => {
  return {
    id: "clusters",
    type: "circle",
    source: "locations",
    filter: ["has", "point_count"],
    paint: skin?.clusterLayer ?? {},
  };
};

export const ClusterCountLayer = (skin) => {
  return {
    id: "cluster-count",
    type: "symbol",
    source: "locations",
    filter: ["has", "point_count"],
    layout: {
      "text-field": "{point_count_abbreviated}",
      "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
      "text-size": 12,
      ...skin,
    },
    paint: {
      "text-color": "#fff",
    },
  };
};

export const UnclusteredPointLayer = {
  id: "unclustered-point",
  type: "circle",
  source: "locations",
  filter: ["!=", "cluster", true],
  interactive: true,
  paint: {
    "circle-color": ["get", "color"],
    "circle-radius": 6,
    "circle-stroke-width": 1,
    "circle-stroke-color": "#fff",
  },
  /*layout: {
    "icon-image": ["get", "icon"],
    "icon-padding": 0,
    "icon-allow-overlap": true,
    "icon-size": 0.5,
  },*/
};

export const RegionBorderLayer = {
  id: "region-border",
  type: "line",
  source: "regions",
  layout: {
    visibility: "visible",
  },
  paint: {
    "line-color": theme.palette.primary.main,
    "line-width": 0.5,
    "line-opacity": 0.25,
  },
};

export const RegionDensityLayer = {
  id: "region-density",
  type: "fill",
  source: "regions",
  layout: {
    visibility: "none",
  },
  paint: {
    "fill-color": [
      "case",
      ["==", ["get", "density"], 0],
      "#f6fbff",
      ["<=", ["get", "density"], 10],
      "#fbe0ef",
      ["<=", ["get", "density"], 25],
      "#f5b3d7",
      ["<=", ["get", "density"], 50],
      "#ee80bc",
      ["<=", ["get", "density"], 100],
      "#e74da1",
      [">", ["get", "density"], 100],
      "#e1268c",
      ["boolean", ["feature-state", "hover"], false],
      "#e1268c",
      "#455A64",
    ],
    "fill-opacity": [
      "case",
      ["boolean", ["feature-state", "hover"], false],
      1,
      0.95,
    ],
  },
};
